import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function DriverModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  campuses = [],
}) {
  const handleOnSave = async (values) => {
    let campusInfo = values.campus;
    values.campus = values.campus.value;

    const res = await apiRequest({
      path: apiPaths.drivers,
      data: values,
      method: "POST",
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onSave({
      ...res,
      campus_info: {
        name: campusInfo.label,
        id: campusInfo.value,
      },
    });
  };

  return (
    <Modal
      title={"Create Driver"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={handleOnSave}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
              }
            : {}
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="First Name"
              name="user_fname"
              rules={[
                {
                  required: true,
                  message: "Please input first name",
                },
              ]}
            >
              <Input placeholder="first name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Last Name"
              name="user_lname"
              rules={[
                {
                  required: true,
                  message: "Please input last name",
                },
              ]}
            >
              <Input placeholder="last name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="user_email"
              rules={[
                {
                  required: true,
                  message: "Please input driver email",
                },
              ]}
            >
              <Input placeholder="email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Mobile Number"
              name="user_mobile"
              rules={[
                {
                  required: true,
                  message: "Please input driver mobile number",
                },
              ]}
            >
              <Input placeholder="mobile number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Campus"
              name="campus"
              rules={[
                {
                  required: true,
                  message: "Please select campus",
                },
              ]}
            >
              <Select
                showSearch
                labelInValue
                placeholder="Search and Select campus"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={campuses}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Save"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default DriverModal;
